// extracted by mini-css-extract-plugin
export default {"button":"Button_button__SYhP+","two":"Button_two__Qog3n","bgTwo":"Button_bgTwo__7p4Zy","bg":"Button_bg__locio","one":"Button_one__ePyic","icon":"Button_icon__JkZ1a"};